import Image from 'app/Components/Shared/Image/image';
import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { setFilterList, GetOrgUserList, findUserByNameOrByPhone, setDataIndexToLoad, setCurrentStep, resetTempList, setActionType } from './OrgUsersManagementSlice';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import { EnumStep, filterType, searchType } from './General';
import { regexPatterns } from '../../../utilities/validation/validationVariables';
import { TextInputEnum, validateInput } from '../../../utilities/validation/InputValidation';
import TextInput from '../../Shared/TextInput/TextInput';

const FilterTable = (props) => {
  const [searchError, setSearchError] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const searchRef = useRef();

  const FilterData = async (type, value) => {
    props.setFilterList({ type, value });
    props.setDataIndexToLoad(0);
    setSearchValue('');
    await props.GetOrgUserList();
  };

  const findUser = async (event, searchIconClick = false) => {
    var value = searchIconClick ? event : event.target.value;
    setSearchError('');
    setSearchValue(value);
    if (value != '') {
      var errInput = '';
      var type = '';
      var numbersRegex = new RegExp(regexPatterns.numbersRegex);
      var lettersRegex = new RegExp(regexPatterns.lettersRegex);

      if (numbersRegex.test(value)) {
        errInput = validateInput(value, TextInputEnum.Phone);
        type = searchType.Phone;
      } else if (lettersRegex.test(value)) {
        type = searchType.Name;
      } else {
        setSearchError('אנא הכנס ערך תקין');
      }

      if (errInput == '' && (searchIconClick || (type == searchType.Name && event.key == 'Enter') || (type == searchType.Phone && event.type == 'change'))) {
        props.setFilterList();
        await props.findUserByNameOrByPhone({ type, value }).then((res) => {
          if (res.payload?.countOfRows == 0) {
            props.setSearchErrValue(searchValue);
          }
        });
      } else {
        setSearchError(errInput);
      }
    } else {
      props.resetTempList();
    }
  };

  const getValue = (type) => {
    return props.data.filterList.find((f) => f.type == type)?.value;
  };

  const getOptions = (type, list) => {
    if (getValue(type)) return [...list, '-'];
    else return list;
  };

  const getActionTypeOptions = () => {
    const options = [];
    if (props.allowActivate && props.allowUpgrade) options.push({ label: 'סוג פעולה', value: 'activateAndUpgrade' });
    if (props.allowActivate) options.push({ label: 'אקטוב', value: 'activate' });
    if (props.allowUpgrade) options.push({ label: 'שדרוג', value: 'upgrade' });
    return options;
  };

  const getSelectedActionType = () => {
    const currentValue = props.actionType === '' ? 'activateAndUpgrade' : props.actionType;
    return getActionTypeOptions().find((option) => option.value === currentValue) || null;
  };

  const resetFilter = async () => {
    setSearchValue('');
    props.setFilterList();
    await props.GetOrgUserList();
  }

  return (
    <div className='filterContainer'>
      <div className='filters'>
        <label className='filterText'>
          <Image src={require('./icons/filter.svg')} />
          בחר מסננים :
        </label>
        <ReactSelect
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          placeholder={getSelectedActionType()?.label || 'סוג טעינה'}
          value={getSelectedActionType()}
          name='actionType'
          options={getActionTypeOptions()}
          onChange={(option) => {
            if (option) {
              props.setActionType(option.value === 'activateAndUpgrade' ? '' : option.value);
              props.GetOrgUserList();
            }
          }}
        />
        <ReactSelect
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          placeholder={getValue(filterType.UserType) || 'מדרג'}
          value={getValue(filterType.UserType) || ''}
          name='userType'
          options={getOptions(filterType.UserType, props.data.userTypeList)}
          onChange={(value) => {
            FilterData(filterType.UserType, value);
          }}
        />
        <ReactSelect
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          placeholder={getValue(filterType.Status) || 'סטטוס'}
          value={getValue(filterType.Status) || ''}
          name='status'
          options={getOptions(filterType.Status, props.data.statusList)}
          onChange={(value) => {
            FilterData(filterType.Status, value);
          }}
        />
        <ReactSelect
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          placeholder={getValue(filterType.PlanName) || 'תוכנית'}
          value={getValue(filterType.PlanName) || ''}
          name='PlanName'
          options={getOptions(filterType.PlanName, props.data.planList)}
          onChange={(value) => {
            FilterData(filterType.PlanName, value);
          }}
        />

        <div className='searchBar'>
          <TextInput
            id='search'
            className='searchInput'
            placeholder='חיפוש מנוי לפי שם או מספר טלפון'
            value={searchValue}
            error={searchError}
            onChange={(e) => findUser(e)}
            ref={searchRef}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                findUser(e);
              }
            }}
          />
          <Image className='searchIcon' src={require('./icons/searchIcon.svg')} onClick={() => findUser(searchValue, true)} />
        </div>
        <p className='resetFilter' onClick={() => resetFilter()}>
          איפוס{' '}
        </p>
      </div>
      <button className={`whiteBtn`} onClick={() => props.setCurrentStep(EnumStep.UploadFile)}>
        <Image src={require('./icons/upload.svg')} />
        טעינת קובץ חדש{' '}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.orgUsersManagement,
    actionType: state.orgUsersManagement.actionType,
  };
};

const mapDispatchToProps = {
  setFilterList,
  GetOrgUserList,
  findUserByNameOrByPhone,
  setDataIndexToLoad,
  setCurrentStep,
  resetTempList,
  setActionType,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterTable);
